import {store} from "../store";
import Vue from 'vue';

const state = {
    token: localStorage.getItem('access_token') || null,
    loggedUser: null,
    loadWorkplace: false,
};

const getters = {
    loggedIn(state){
        return state.token !== null
    },
    getToken(state){
        return state.token;
    },
    loggedUser(state){
        return state.loggedUser;
    },
    isLoggedUserSuperAdmin(state){
        try{
            return state.loggedUser.group.id === 1;
        }catch (e) {
            return false;
        }

    },
    loadWorkplace(state){
        return state.loadWorkplace;
    }
};

const mutations = {
    storeToken(state, payload){
        state.token = payload;
    },
    destroyToken(state){
        state.token = null;
    },
    loggedUser(state, payload) {
        // this.consoleLog('>>>LoggedUserInfosChanged<<<');
        state.loggedUser = payload;
    },
    loadWorkplace(state, payload) {
        state.loadWorkplace = payload;
    }
};

const actions = {
    loggedUser({commit}, payload){
        commit('loggedUser', payload);
    },

    loadWorkplace( {commit}, payload){
        commit('loadWorkplace', payload);
    },

    login( {commit, dispatch}, payload){
        try{
            return new Promise((resolve, reject) => {
                
                Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                Vue.axios.post('/login', {
                    email: payload.email,
                    password: payload.password,
                }).then(response => {
                    console.log('response-login:', response);
                    if(response.data.response) {
                        if (!response.data.response.credential_correct) {
                            console.log('wrong-credential', response);
                            resolve(response);
                            return;
                        } else if (!response.data.response.access) {
                            resolve(response);
                            return;
                        }
                        return;
                    }
                    dispatch('storeToken', response.data.access_token);
                    resolve(response);
                    dispatch('loggedUser', response.data.user);
                    dispatch('loadWorkplace', true);
                    resolve();

                }).catch(error => {
                    // vm.consoleLog(error);
                    reject(error);
                    dispatch('loadWorkplace', false);
                });
            });
        }catch(e){
            // this.consoleLog(e);
        }
    },

    loggedUserInfos( context ){
        return new Promise((resolve, reject) => {
            Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters.getToken;
            Vue.axios.get('eu')
                .then(response => {
                    // this.consoleLog(response);
                    if (!response.data.success) {
                        context.dispatch('loadWorkplace', false);
                    }
                    context.dispatch('loggedUser', response.data.response);
                    context.dispatch('loadWorkplace', true);
                    resolve(response);

                }).catch(error => {
                // this.consoleLog(error);
                    context.dispatch('loadWorkplace', false);
                    reject(error);
            })
        });
    },

    storeToken( {commit, dispatch}, payload){
        commit('storeToken', payload);
        localStorage.setItem('access_token', payload);
        if(!payload){
            localStorage.removeItem('access_token');
            dispatch('loadWorkplace', false);
        }
    },

    logout( context ){
        if(context.getters.loggedIn){
            return new Promise((resolve, reject) => {
                try{
                    // vm.consoleLog('logging out');
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
                    Vue.axios.post('logout')
                        .then(response => {
                            // vm.consoleLog(response);
                            localStorage.removeItem('access_token');
                            context.commit('destroyToken');
                            resolve(response);

                        }).catch(error => {
                            // vm.consoleLog(error);
                            localStorage.removeItem('access_token');
                            context.commit('destroyToken');
                            reject(error);
                    });
                }catch (e) {
                    return e;
                }

            });
        }
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};

